
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import './pagination.scss';

const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,

  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul
      className={classnames('pagination-container', { [className]: className })}
    >
      <li
        className={classnames('pagination-item  mx-2 w-10 h-10 font-semiblod rounded-full border-2 hover:text-pink-350 hover:border-pink-350 transition-all', {
          disabled: currentPage === 1
        })}
        onClick={onPrevious}
      >
        <div className="arrow left" />
      </li>
      {paginationRange.map(pageNumber => {
        if (pageNumber === DOTS) {
          return <li key={pageNumber} className="pagination-item dots mx-2 w-10 h-10 font-semiblod rounded-full border-2 hover:text-pink-350 hover:border-pink-350 transition-all">&#8230;</li>;
        }

        return (
          <li key={pageNumber}
            className={classnames('pagination-item mx-2 w-10 h-10 font-semiblod rounded-full border-2 hover:text-pink-350 hover:border-pink-350 transition-all', {
              selected: pageNumber === currentPage
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={classnames('pagination-item mx-2 w-10 h-10 font-semiblod rounded-full border-2 hover:text-pink-350 hover:border-pink-350 transition-all', {
          disabled: currentPage === lastPage
        })}
        onClick={onNext}
      >
        <div className="arrow right" />
      </li>
    </ul>
  );
};

export default Pagination;